/* RAKAN blend mixer: pick a pack size (125/250g), distribute it across origins in GRAMS,
   price is computed live from each origin's per-kg cost, snapped to a price-point variant so
   Shopify checkout gets one clean line at the right price + the recipe as line-item properties. */
(function () {
  'use strict';
  const root = document.getElementById('rkMixer');
  if (!root) return;

  const cfg = JSON.parse(document.getElementById('rkMixerConfig').textContent);
  const STEP = 5;
  const rows = [...root.querySelectorAll('.mix-row')];
  const donut = root.querySelector('.mix-donut');
  const donutLabel = donut.querySelector('span');
  const warn = root.querySelector('.mix-total-warn');
  const addBtn = root.querySelector('#rkMixAdd');
  const sizeBtns = [...root.querySelectorAll('.mix-size')];
  const priceEl = root.querySelector('.mix-price strong');
  const unitEl = root.querySelector('.mix-price span');
  const palette = ['#c79a4e', '#f4ead7', '#7a4a23', '#e0c180', '#3f2215', '#9c6b3f', '#d9b877', '#5b3a1e', '#b8863b', '#efe0c0', '#2e1a0d'];
  const roastGroup = root.querySelector('#rkMixRoast');
  const tahwigGroup = root.querySelector('#rkMixTahwig');
  let selRoast = 'وسط';
  let selTahwig = 'سادة';
  const isEn = () => window.RK_I18N && window.RK_I18N.lang === 'en';
  const arNum = n => isEn() ? String(n) : String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
  const gUnit = () => isEn() ? 'g' : ' جم';
  const fmtPrice = egp => isEn() ? ('EGP ' + egp) : (arNum(egp) + ' ج.م');
  const fmtUnit = g => isEn() ? ('/ ' + g + 'g, ground to your taste') : ('/ ' + arNum(g) + ' جرام، طحنة على ذوقك');

  // price-point variants: { "60": id, "65": id, ... }
  const VMAP = cfg.variants || {};
  const PSTEP = cfg.priceStep || 5;
  const points = Object.keys(VMAP).map(Number).sort((a, b) => a - b);

  let TOTAL = parseInt(cfg.grams, 10) || 250;     // active pack weight, grams
  let curVariant = null;
  let curPrice = null;

  /* legend dot per origin row, matching its donut segment color */
  rows.forEach((r, i) => {
    const dot = document.createElement('span');
    dot.className = 'm-dot';
    dot.style.cssText = `display:inline-block;width:13px;height:13px;border-radius:50%;margin-inline-end:.5rem;vertical-align:baseline;background:${palette[i % palette.length]};border:1.5px solid rgba(244,234,215,.5);`;
    const nameEl = r.querySelector('.m-name');
    nameEl.insertBefore(dot, nameEl.firstChild);
  });

  const state = {};
  rows.forEach(r => { state[r.dataset.key] = parseInt(r.querySelector('input').value, 10); });

  function total() { return Object.values(state).reduce((a, b) => a + b, 0); }

  /* التحويج is a paid upgrade: every step above سادة adds 25 EGP on a 250g pack
     and 15 EGP on a 125g pack, cumulatively (حبهان +1, خديوي +2, راكان +3) */
  const SPICE_ADD = { 250: 25, 125: 15 };
  function spiceUplift() {
    const on = tahwigGroup && tahwigGroup.querySelector('[data-val].is-on');
    const step = on ? (parseInt(on.dataset.step, 10) || 0) : 0;
    return step * (SPICE_ADD[TOTAL] || SPICE_ADD[250]);
  }

  /* Snap to the nearest EXISTING price-point variant. The ladder is step 5 up to 340
     and step 10 above it, so a fixed-step round could land on a price with no variant
     and silently disable add-to-cart. Reading the real points makes the ladder shape
     irrelevant and removes that failure mode. */
  function snapToPoint(v) {
    if (!points.length) return Math.round(v / PSTEP) * PSTEP;
    let best = points[0];
    for (let i = 1; i < points.length; i++) {
      // <= so an exact tie takes the HIGHER point: points ascend, and rounding a
      // half-step down every time would quietly undercharge the shop.
      if (Math.abs(points[i] - v) <= Math.abs(best - v)) best = points[i];
    }
    return best;
  }

  /* live price from each origin's per-kg cost, snapped to the nearest price-point variant */
  function computePrice() {
    let egp = 0;
    rows.forEach(r => { const kg = parseFloat(r.dataset.kg) || 0; egp += (state[r.dataset.key] || 0) * kg / 1000; });
    let snapped = snapToPoint(egp + spiceUplift());
    curPrice = snapped;
    curVariant = VMAP[String(snapped)] || null;
    if (priceEl) priceEl.textContent = fmtPrice(snapped);
    if (unitEl) unitEl.textContent = fmtUnit(TOTAL);
    return snapped;
  }

  /* nudge the blend back to an exact target in STEP increments, largest buckets first */
  function fixSum(target) {
    let diff = target - total();
    const order = rows.map(r => r.dataset.key).sort((a, b) => state[b] - state[a]);
    let i = 0;
    while (diff !== 0 && i < 10000) {
      const k = order[i % order.length];
      if (diff > 0) { state[k] += STEP; diff -= STEP; }
      else if (state[k] >= STEP) { state[k] -= STEP; diff += STEP; }
      i++;
    }
  }

  function paint() {
    let acc = 0;
    rows.forEach((r, i) => {
      const key = r.dataset.key;
      const val = state[key];
      const input = r.querySelector('input');
      input.max = TOTAL;
      input.value = val;
      const fillPct = TOTAL ? (val / TOTAL * 100) : 0;
      input.style.setProperty('--fill', fillPct + '%');
      input.setAttribute('aria-valuetext', arNum(val) + gUnit());
      r.querySelector('.m-pct').textContent = arNum(val) + gUnit();
      if (val > 0) {
        const segPct = val / TOTAL * 100;
        r._seg = `${palette[i % palette.length]} ${acc}% ${acc + segPct}%`;
        acc += segPct;
      } else { r._seg = null; }
    });
    const segs = rows.map(r => r._seg).filter(Boolean);
    if (acc < 100) segs.push(`rgba(244,234,215,.15) ${acc}% 100%`);
    donut.style.background = `conic-gradient(${segs.join(',')})`;
    const t = total();
    donutLabel.textContent = arNum(t) + gUnit();
    const ok = t === TOTAL;
    if (isEn()) {
      warn.textContent = ok ? `Your blend is ${TOTAL}g, ready to order` : (t < TOTAL ? `${TOTAL - t}g left to reach ${TOTAL}g` : `Over by ${t - TOTAL}g, we rebalanced it for you`);
    } else {
      warn.textContent = ok ? `خلطتك ${arNum(TOTAL)} جم، جاهزة للطلب` : (t < TOTAL ? `فاضل ${arNum(TOTAL - t)} جم توصل ${arNum(TOTAL)}` : `الخلطة زادت ${arNum(t - TOTAL)} جم وظبطناها بدالك`);
    }
    warn.style.color = ok ? 'rgba(244,234,215,.85)' : '#e8b04b';
    /* spice upcharges differ per pack size, keep the pill hints honest */
    if (tahwigGroup) {
      const add = SPICE_ADD[TOTAL] || SPICE_ADD[250];
      tahwigGroup.querySelectorAll('[data-val]').forEach(b => {
        const hint = b.querySelector('.mix-add');
        const step = parseInt(b.dataset.step, 10) || 0;
        if (hint) hint.textContent = step ? ('+' + arNum(step * add)) : '';
      });
    }
    computePrice();
    addBtn.disabled = !ok || !curVariant;
    addBtn.classList.toggle('is-off', !ok || !curVariant);
  }

  /* keep the blend at exactly TOTAL grams by trimming the other origins proportionally */
  function rebalance(changedKey) {
    const t = total();
    if (t <= TOTAL) return;
    let excess = t - TOTAL;
    const others = rows.map(r => r.dataset.key).filter(k => k !== changedKey && state[k] > 0);
    const pool = others.reduce((a, k) => a + state[k], 0);
    others.forEach(k => {
      if (excess <= 0) return;
      const cut = Math.min(state[k], Math.round(excess * (state[k] / (pool || 1))) || 1);
      state[k] -= cut; excess -= cut;
    });
    let i = 0;
    while (excess > 0 && others.length) {
      const k = others[i % others.length];
      if (state[k] > 0) { state[k]--; excess--; }
      i++;
      if (i > 5000) break;
    }
  }

  /* switch pack size: rescale the current mix to the new total, recompute price */
  function applySize(btn) {
    const newTotal = parseInt(btn.dataset.grams, 10) || TOTAL;
    if (newTotal !== TOTAL) {
      const f = newTotal / TOTAL;
      rows.forEach(r => { const k = r.dataset.key; state[k] = Math.max(0, Math.round((state[k] * f) / STEP) * STEP); });
      const wasEmpty = total() === 0;
      TOTAL = newTotal;
      /* an untouched blend stays empty: the customer builds it up from zero */
      if (!wasEmpty) { fixSum(TOTAL); }
    }
    sizeBtns.forEach(b => { const on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    paint();
  }

  rows.forEach(r => {
    const input = r.querySelector('input');
    input.addEventListener('input', () => {
      state[r.dataset.key] = parseInt(input.value, 10);
      rebalance(r.dataset.key);
      paint();
    });
  });

  /* Preset blends are written by the shop owner in plain Arabic, one bean per line:
     "برازيلي ريو 100". Numbers can be ratios; fixSum scales them to the pack weight.
     Anything unparseable is ignored so a typo can never break the mixer. */
  function parseRecipe(text) {
    const wanted = {};
    String(text || '').split(/[\n,،;]+/).forEach(line => {
      const t = line.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))
                    .replace(/[\u200e\u200f]/g, '').trim();
      const m = t.match(/^(.+?)[\s:=\-–]*(\d+)\s*(?:جم|جرام|g|gram)?\.?$/);
      if (!m) return;
      const name = m[1].replace(/[:=\-–\s]+$/, '').trim();
      const grams = parseInt(m[2], 10);
      if (name && grams >= 0) wanted[name] = grams;
    });
    return wanted;
  }

  function applyRecipe(text) {
    const wanted = parseRecipe(text);
    const keys = Object.keys(wanted);
    if (!keys.length) return false;
    rows.forEach(r => {
      const n = (r.dataset.name || '').trim();
      let g = wanted[n];                                    // exact name wins
      if (g === undefined) {                                // then a partial match
        for (let i = 0; i < keys.length; i++) {
          if (n.indexOf(keys[i]) !== -1 || keys[i].indexOf(n) !== -1) { g = wanted[keys[i]]; break; }
        }
      }
      state[r.dataset.key] = g || 0;
    });
    return true;
  }

  root.querySelectorAll('[data-preset-recipe]').forEach(btn => {
    btn.addEventListener('click', () => {
      try {
        if (!applyRecipe(btn.dataset.presetRecipe)) return;
        fixSum(TOTAL);
        paint();
      } catch (e) { /* never let a bad recipe break the blend builder */ }
    });
  });

  sizeBtns.forEach(btn => btn.addEventListener('click', () => applySize(btn)));

  /* roast is a recipe note; تحويج also moves the price, so repaint after either */
  function bindPillGroup(group, set) {
    if (!group) return;
    group.querySelectorAll('[data-val]').forEach(btn => btn.addEventListener('click', () => {
      set(btn.dataset.val);
      group.querySelectorAll('[data-val]').forEach(b => {
        const on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      paint();
    }));
  }
  bindPillGroup(roastGroup, v => selRoast = v);
  bindPillGroup(tahwigGroup, v => selTahwig = v);

  if (addBtn) addBtn.addEventListener('click', () => {
    if (total() !== TOTAL || !curVariant) return;
    const properties = { 'الحجم': arNum(TOTAL) + (isEn() ? 'g' : ' جم') };
    properties['التحميص'] = selRoast;
    properties['التحويج'] = selTahwig;
    rows.forEach(r => { if (state[r.dataset.key] > 0) properties[r.dataset.name] = arNum(state[r.dataset.key]) + (isEn() ? 'g' : ' جم'); });
    properties['السعر'] = fmtPrice(curPrice);
    window.rkAddToCart({ items: [{ id: curVariant, quantity: 1, properties }] }, 'خلطتك اتضافت لعربيتك');
  });

  // honor a pre-marked active size button on load
  const initial = sizeBtns.find(b => b.classList.contains('is-active'));
  if (initial) applySize(initial); else paint();
})();
